import { render, staticRenderFns } from "./ConfirmedDialogTemplate.vue?vue&type=template&id=10a2759e"
import script from "./ConfirmedDialogTemplate.vue?vue&type=script&lang=js"
export * from "./ConfirmedDialogTemplate.vue?vue&type=script&lang=js"
import style0 from "./ConfirmedDialogTemplate.vue?vue&type=style&index=0&id=10a2759e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VIcon})
